import { FC } from "react"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import Tooltip, { TooltipPosition } from "@/components/shared/Tooltip"

interface AlertDetailRowProps {
   iconName: IconProps["name"]
   iconColor?: IconColor
   value: number | string | string[]
   text: string
}

const AlertDetailRow: FC<AlertDetailRowProps> = ({
   iconName,
   iconColor,
   value,
   text,
}) => {
   const isMultiple = Array.isArray(value) && value.length > 1

   const displayValue = isMultiple ? (
      <span className="alert-layout__detail-location-info-value alert-layout__detail-location-info-value--multiple">
         Multiple
         <Tooltip
            content={
               <span className="alert-layout__detail-location-info-tooltip">
                  {(value as string[]).map((val) => (
                     <span
                        key={val}
                        className="alert-layout__detail-location-info-tooltip-item"
                     >
                        <Icon
                           name={iconName}
                           color={IconColor.HONOLULU_BLUE}
                           size="12"
                        />
                        {val}
                     </span>
                  ))}
               </span>
            }
            position={TooltipPosition.TOP}
         >
            <span className="alert-layout__detail-location-info-icon">
               <Icon
                  name="info"
                  color={iconColor ?? IconColor.HONOLULU_BLUE}
                  size="16"
               />
            </span>
         </Tooltip>
      </span>
   ) : (
      <span className="alert-layout__detail-location-info-value">
         {Array.isArray(value) ? value[0] : value}
      </span>
   )

   return (
      <span className="alert-layout__detail-location-item">
         <Icon
            name={iconName}
            color={iconColor ?? IconColor.HONOLULU_BLUE}
            size="48"
         />
         <span className="alert-layout__detail-location-info">
            <span className="alert-layout__detail-location-info-title">
               {text}
            </span>
            {displayValue}
         </span>
      </span>
   )
}
export default AlertDetailRow
